import {UserDealer} from "../containers/App/models"

export const SpinnerFragment = () => (
    <div className="d-flex justify-content-center modal-center-spinner">
        {/* <MDBSpinner className="m-2" grow style={{width: "2rem", height: "2rem"}} role="status">
            <span className="visually-hidden mr-3">Loading...</span>
        </MDBSpinner>
        <MDBSpinner className="m-2" grow style={{width: "2rem", height: "2rem"}} role="status">
            <span className="visually-hidden mr-3">Loading...</span>
        </MDBSpinner>
        <MDBSpinner className="m-2" grow style={{width: "2rem", height: "2rem"}} role="status">
            <span className="visually-hidden mr-3">Loading...</span>
        </MDBSpinner> */}
        <div className="k-loading-mask">
            <span className="k-loading-text">Loading</span>
            <div className="k-loading-image"></div>
            <div className="k-loading-color"></div>
        </div>
    </div>
)

export const SpinnerGrid = () => (
    <div className="d-flex justify-content-center grid-center-spinner">
        {/* <MDBSpinner className="m-2" grow style={{width: "2rem", height: "2rem"}} role="status">
            <span className="visually-hidden mr-3">Loading...</span>
        </MDBSpinner>
        <MDBSpinner className="m-2" grow style={{width: "2rem", height: "2rem"}} role="status">
            <span className="visually-hidden mr-3">Loading...</span>
        </MDBSpinner>
        <MDBSpinner className="m-2" grow style={{width: "2rem", height: "2rem"}} role="status">
            <span className="visually-hidden mr-3">Loading...</span>
        </MDBSpinner> */}
        <div className="k-loading-mask">
            <span className="k-loading-text">Loading</span>
            <div className="k-loading-image"></div>
            <div className="k-loading-color"></div>
        </div>
    </div>
)

export const LoadingPanel = () => {
    return (
        <div className="k-loading-mask">
            <span className="k-loading-text">Loading</span>
            <div className="k-loading-image"></div>
            <div className="k-loading-color"></div>
        </div>
    )
}
